import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core'
import * as fileSaver from 'file-saver'
import { ChartType } from '../../../shared/enums/chart-type.enum'

import { AggregationDataset } from '../../../shared/interfaces/visualizations/aggregation-dataset.interface'
import { Aggregation } from '../../../shared/interfaces/visualizations/aggregation.interface'
import { PieChartItem } from '../../charts/pie-chart/interfaces/pie-chart-item'
import { IncentiveFamily } from '../../../shared/enums/incentive.family'
import { Country } from '../../../shared/interfaces/resources/country.interface'

@Component({
  selector: 'app-aggregation-wrapper',
  templateUrl: './aggregation-wrapper.component.html',
  styleUrls: ['./aggregation-wrapper.component.scss']
})
export class AggregationWrapperComponent implements OnChanges {
  @Input() aggregation: Aggregation
  @Input() selectedIncentiveType: string
  @Input() selectedCountries: string[] = []

  @Output()
  pieSliceClick = new EventEmitter<PieChartItem>();
  selectedDataset: AggregationDataset
  ChartType = ChartType
  @Input() selectedFamily: IncentiveFamily = IncentiveFamily.RDTAX

  ngOnChanges(): void {
    this.selectedDataset = this.aggregation.datasets[0]
  }

  selectDataset(eventTarget: any): void {
    this.selectedDataset = this.aggregation.datasets.find(
      (d: AggregationDataset) => d.id === eventTarget.value
    )
  }

  downloadDataset(dataset: AggregationDataset): void {
    const blob = new Blob([dataset.csv], {
      type: 'text/csv;charset=utf-8;'
    })
    fileSaver.saveAs(blob, `${this.aggregation.label} - ${dataset.label}.csv`)
  }

  onPieSliceClick(item: PieChartItem): void {
    this.pieSliceClick.emit(item);
  }
}
